import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH EVENT LIVE TO EDIT ********************
export const fetchEventLive = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EVENT_LIVE_LOADING,
			payload: true
		});

		// To do: change to events live url
		const response = await services.get(`/products/liveevents/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EVENT_LIVE_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_EVENT_LIVE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
